import mojs from '@mojs/core/dist/mo.umd.js';

class Animate {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-animate]',
            delay: 300,
            duration: 400,
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.$scope.each((index, scope) => {
            let $scope = $(scope);
            this.setAnimation($scope);

            this.animateIfInViewport($scope)
            $(window).on('scroll', (e) => {
                this.animateIfInViewport($scope);
            });
        });
    }

    animateIfInViewport($scope) {
        if ($scope.data('is-animated') == true || !this.isInViewport($scope)) {
            return;
        }

        $scope.data('is-animated', true);

        this.animate($scope);
    }

    setAnimation($scope) {
        let settings = Object.assign({
            el: $scope[0],
            duration: this.config.duration,
            easing: 'ease.out',
            delay: this.config.delay
        }, $scope.data());

        delete settings.animate;
        delete settings.isAnimated;
        delete settings.timeline;

        let animation = new mojs.Html(settings);
        $scope.data('animation', animation);
    }

    animate($scope) {
        $scope.data('animation').play();
    }

    isInViewport($scope) {
        let elementTop = $scope.offset().top;
        let elementBottom = elementTop + $scope.outerHeight();

        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }
}

export default new Animate;
